import { getDiscoCompanyNativeOptions } from "../../components/AdminCompanySelect/DiscoCompanyMenuItems";
//#region Imports
import React, { useEffect, useRef, useState } from 'react';
import { clampIsoDateToToday, getTodayIsoDate } from "../../utils/reportDateLimits";
//MUI
import { Box, Button, Popover, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../components/AppLoader/AppLoader';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { useSelector } from 'react-redux';
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from '../../images/eops.png';
import excel from '../../images/excel.png';
import mepcoLogo from '../../images/mepcoLogo.png';
import pdf from '../../images/pdf.png';
import print from '../../images/print.png';
import { cfpBaseUrl } from '../../network/urls';
import { openJsPdfInNewTab, convertDate, convertDatewithTime, printStamp, subdivisionName, getName } from '../../services/Functions';
import { internalIconStyles } from '../../style/common';
import '../../style/common.scss';
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../images/pitc.png';
import { getEffectiveAdminCompanyCode, getInitialAdminOfficeCode, resolveOfficeCodeForAdmin, resolveReportGoOfficeCode } from "../../utils/adminCompany";
//#endregion

const MeterReadingCorrectionReports = () => {
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } = useSelector(state => state.auth)
    const companyCode = code.slice(0, 2)
    const offCode = code
    const [isLoading, setIsLoading] = React.useState(false);
      const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);
         const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

    // const { officeCode: offCode } = useSelector(state => state.officeCode)
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [totals, setTotals] = useState({});
    // const [officeCode, setOfficeCode] = useState('');
    const [dateFrom, setDateFrom] = useState(getCurrentDate())
    const [dateTo, setDateTo] = useState(getCurrentDate())
    const tableRef = useRef(null);
    const [dateFromDisplay, setDateFromDisplay] = useState('')
    const [dateToDisplay, setDateToDisplay] = useState('')
    const [category, setCategory] = useState('')
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [circleCode, setCircleCode] = useState('');
    const [circleName, setCircleName] = useState('');
    const [officeCode, setOfficeCode] = useState('');
    useEffect(() => {
      if (String(code) === "10" && selectedAdminCompanyCode) {
        const company = String(selectedAdminCompanyCode);
        setSelectedCompanyCode(company);
        setOfficeCode(company);
      }
    }, [code, selectedAdminCompanyCode]);

    useEffect(() => {
      if (String(code) !== "10") return;
      if (circleCode || selectedDivision || selectedSubDivision) return;
      const company = getEffectiveAdminCompanyCode(
        code,
        selectedCompanyCode,
        selectedAdminCompanyCode,
      );
      if (company) {
        setOfficeCode(company);
      }
    }, [
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    ]);
    const [officeName, setOfficeName] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRemarks, setSelectedRemarks] = useState('');
    const [selectedPerson, setSelectedPerson] = useState('');
    const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
    const [selectedPerson1, setSelectedPerson1] = useState('');
    const [registeredByOptions, setRegisteredByOptions] = useState([]);
    const [isGoDisabled, setIsGoDisabled] = useState(true); 
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
    useEffect(() => {
        if (circleCode) {
            setOfficeCode(circleCode);
        }
    }, [circleCode]);

    // Fetch subDivisions for code == 10
   useEffect(() => {
     if (code == 10 && selectedCompanyCode) {
       const fetchSubDivisions = async () => {
         setViewBackdrop(true);
         const myHeaders = new Headers();
         myHeaders.append('Authorization', token);
         const formdata = new FormData();
         formdata.append('companyCode', selectedCompanyCode);
         const requestOptions = {
           method: 'POST',
           headers: myHeaders,
           body: formdata,
           redirect: 'follow',
         };
         try {
           const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
           if (response.ok) {
             const result = await response.json();
             if (result.status === '200') {
               setSubDivisions(result.message);
               setApiData(result.message);
               // Populate circles
               const circles = result.message.reduce((acc, curr) => {
                 if (!acc.some(item => item.circleCode === curr.circleCode)) {
                   acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                 }
                 return acc;
               }, []);
               setFilteredCircles(circles);
             } else {
               setSubDivisions([]);
               setFilteredCircles([]);
             }
           } else {
             throw new Error(`Request failed with status ${response.status}`);
           }
         } catch (error) {
           setSubDivisions([]);
           setFilteredCircles([]);
         } finally {
           setViewBackdrop(false);
         }
       };
       fetchSubDivisions();
     } else if (code != 10) {
       // For code != 10, populate circles from localStorage subDivisions
       const circles = subDivisions.reduce((acc, curr) => {
         if (!acc.some(item => item.circleCode === curr.circleCode)) {
           acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
         }
         return acc;
       }, []);
       setFilteredCircles(circles);
     }
   }, [code, selectedCompanyCode, token, cfpBaseUrl]);
 
   const handleChangeCompany = async (e) => {
     const selectedCompany = e.target.value;
     setSelectedCompanyCode(selectedCompany);
     setOfficeCode(selectedCompany);
     setOfficeName(getCompanies(selectedCompany) || '');
 
     if (code == 10 && selectedCompany) {
       setViewBackdrop(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompany);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             // Reset dropdowns
             setCircleCode('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setCircleName('');
             setFilteredDivisions([]);
             setFilteredSubDivisions([]);
 
             // Populate circles
             const circles = result.message.reduce((acc, curr) => {
               if (!acc.some(item => item.circleCode === curr.circleCode)) {
                 acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
               }
               return acc;
             }, []);
             setFilteredCircles(circles);
           } else {
             setSubDivisions([]);
             setFilteredCircles([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         setSubDivisions([]);
         setFilteredCircles([]);
       } finally {
         setViewBackdrop(false);
       }
     } else if (!selectedCompany) {
       // Reset when no company is selected
       setOfficeName('PITC');
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setCircleName('');
       setFilteredDivisions([]);
       setFilteredSubDivisions([]);
       setFilteredCircles([]);
       setSubDivisions([]);
       setApiData([]);
     }
   };
 
   const handleCircleChange = async (event) => {
     const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
     if (code == 10 && selectedCircleCode && selectedCompanyCode) {
       setViewBackdrop(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('circleCode', selectedCircleCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode(selectedCircleCode);
             setOfficeCode(selectedCircleCode);
             const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
             const circleName = circle?.circleName || '';
             setOfficeName(circleName.concat(' Circle'));
             setCircleName(circleName);
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message
               .filter(item => item.circleCode === selectedCircleCode)
               .reduce((acc, item) => {
                 if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                   acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setViewBackdrop(false);
       }
     } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
       // Handle "All Circle" selection for code == 10
       setViewBackdrop(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode('');
             setOfficeCode(selectedCompanyCode);
             setOfficeName(getCompanies(selectedCompanyCode));
             setCircleName('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setViewBackdrop(false);
       }
     } else if (selectedCircleCode) {
       setCircleCode(selectedCircleCode);
       setOfficeCode(selectedCircleCode);
       const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
       const circleName = circle?.circleName || '';
       setOfficeName(circleName.concat(' Circle'));
       setCircleName(circleName);
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode === selectedCircleCode)
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     } else {
       // Handle "All Circle" for code != 10
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       if (roleTypeName == 'Technical') {
         if (offCode) {
           setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
           let officeName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
           setOfficeName(officeName.concat(' Region'));
           setCircleName('');
           const circles = subDivisions.reduce((acc, curr) => {
             if (!acc.some(item => item.circleCode === curr.circleCode)) {
               acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
             }
             return acc;
           }, []);
           setFilteredCircles(circles);
           const uniqueDivisions = subDivisions.reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
           setFilteredDivisions(uniqueDivisions);
         }
       } else if (roleTypeName == 'Commercial') {
         if (cfcLevelId == 2) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 2));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         } else if (cfcLevelId == 3) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 3));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         }
       }
     }
   };
 
   const handleDivisionChange = async (e) => {
     const selectedDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
       setViewBackdrop(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('divisionCode', selectedDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedDivision(selectedDivisionCode);
             setOfficeCode(selectedDivisionCode);
             const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
             const divisionName = division?.divisionName || '';
             setOfficeName(divisionName.concat(' Division'));
             setSelectedSubDivision('');
             const uniqueSubDivisions = result.message
               .filter(item => item.divisionCode == selectedDivisionCode)
               .reduce((acc, item) => {
                 if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                   acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredSubDivisions(uniqueSubDivisions);
           } else {
             setSubDivisions([]);
             setFilteredSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         setSubDivisions([]);
         setFilteredSubDivisions([]);
       } finally {
         setViewBackdrop(false);
       }
     } else if (selectedDivisionCode) {
       setSelectedDivision(selectedDivisionCode);
       setOfficeCode(selectedDivisionCode);
       const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
       setOfficeName(divisionName.concat(' Division'));
       setSelectedSubDivision('');
       const uniqueSubDivisions = subDivisions
         .filter(item => item.divisionCode == selectedDivisionCode)
         .reduce((acc, item) => {
           if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
             acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredSubDivisions(uniqueSubDivisions);
     } else {
       setSelectedDivision('');
       setOfficeCode(circleCode ? circleCode : offCode);
       let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Circle'));
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     }
   };
 
   const handleSubDivisionChange = async (e) => {
     const selectedSubDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
       setViewBackdrop(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('subDivisionCode', selectedSubDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedSubDivision(selectedSubDivisionCode);
             setOfficeCode(selectedSubDivisionCode);
             const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
             const subDivisionName = subDivision?.subDivisionName || '';
             setOfficeName(subDivisionName.concat(' Sub Division'));
           } else {
             setSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         setSubDivisions([]);
       } finally {
         setViewBackdrop(false);
       }
     } else if (selectedSubDivisionCode) {
       setSelectedSubDivision(selectedSubDivisionCode);
       setOfficeCode(selectedSubDivisionCode);
       const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
       setOfficeName(subDivisionName.concat(' Sub Division'));
     } else {
       setSelectedSubDivision('');
       let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Division'));
       setOfficeCode(selectedDivision ? selectedDivision : offCode);
     }
   };
 
   useEffect(() => {
     if (roleTypeName == 'Technical') { 
       if (offCode) {
         setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
         let offName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
         setOfficeName(offName); 
         setHierarchy(offCode.toString().length);
       }
     } else if (roleTypeName == 'Commercial') {
       if (cfcLevelId == 1) {
         if (offCode) {
                              if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);   
                          }
       } else if (cfcLevelId == 2) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 2));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 3) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 3));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
     }
   }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);
 
   useEffect(() => {
     if (hierarchy) {
       if (hierarchy == 1 || cfcLevelId === 1) {
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 2 || cfcLevelId == 2) {
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 3 || cfcLevelId == 3) {
         setCircleCode(offCode.slice(0, 3));
         const uniqueDivisions = subDivisions
           .filter(item => item.circleCode == offCode.slice(0, 3))
           .reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredDivisions(uniqueDivisions);
       } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
         setSelectedDivision(offCode.slice(0, 4));
         const uniqueSubDivisions = subDivisions
           .filter(item => item.divisionCode == offCode.slice(0, 4))
           .reduce((acc, item) => {
             if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
               acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredSubDivisions(uniqueSubDivisions);
       }
     }
   }, [hierarchy, cfcLevelId, subDivisions]);

    const exportToExcel = () => {
        let offName = officeName;
        let dateToPrint = convertDate(new Date());

        const formattedDateFrom = dateFrom ? convertDate(dateFrom) : '-';
        const formattedDateTo = dateTo ? convertDate(dateTo) : '-';

        const headingText = dateFrom && dateTo && formattedDateFrom === formattedDateTo
            ? `Daily Meter Reading Correction Report for (${offName})`
            : `Meter Reading Correction Report for (${offName}) from ${formattedDateFrom} to ${formattedDateTo}`;

        const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: 'Sheet1' });
        const ws = wb.Sheets['Sheet1'];

        const range = XLSX.utils.decode_range(ws["!ref"]);
        const columnCount = range.e.c - range.s.c + 1;
        XLSX.utils.sheet_add_aoa(ws, [[headingText]], { origin: "A1" });

        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];

        if (!ws["A1"]) ws["A1"] = {};
        ws["A1"].s = { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true } };

        boldDomTheadRows(ws, tableRef.current, 1);

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        const fileName = `${offName} - From ${formattedDateFrom} - to ${formattedDateTo} - Meter-Reading-Correction-Report.xlsx`;

        saveAs(new Blob([wbout]), fileName);
    };

    const connectionTypes = [
        'Tracking Id.',
        'Reference No.',
        // 'Units Charged',
        // 'Units Adjusted',
        // 'Current Amount',
        // 'Adjusted Amount',
        'Reason',
        'Approved By',
        // 'Approved At',
        'Registration Date',
        'Registered By'
    ];


    const [categoryName, setcategoryName] = useState('New Connections')
  


    const getStats = async (officeCode, dateFrom, dateTo) => {
        try {
            setViewBackdrop(true);

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append('Authorization', token);

            const raw = JSON.stringify({
                "officeCode": officeCode,
                "dateFrom": dateFrom,
                "dateTo": dateTo
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "/reports/getMeterReadingCorrectionInfo", requestOptions);
            const result = await response.json();

            if (result.Status === "200") {
                const data = result.data;

                const registeredByList = [
                    ...new Set(data.map((item) => item.registeredBy).filter(Boolean)),
                ];
                const lastModifiedByList = [
                    ...new Set(data.map((item) => item.approvedBy).filter(Boolean)),
                ];

                setRegisteredByOptions(registeredByList);
                setLastModifiedByOptions(lastModifiedByList);
                setTableData(data);
            } else if (result.Status === "400") {
                setTableData([]);
            }
        } catch (e) {
        } finally {
            setViewBackdrop(false); // Always stop loader even on error
        }
    };

    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '26':
                return PESCOLOGO
            case '27':
                return HAZECOLOGO
            case '37':
                return HESCOLOGO
            case '38':
                return SEPCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return "Power Information Technology Company"
            case '11':
                return "Lahore Electric Supply Company"
            case '12':
                return "Gujranwala Electric Power Company"
            case '13':
                return "Faisalabad Electric Supply Company"
            case '14':
                return "Islamabad Electric Supply Company"
            case '15':
                return "Multan Electric Power Company"
            case '26':
                return "Peshawar Electric Supply Company"
            case '27':
                return "Hazara Electric Supply Company"
            case '38':
                return "Sukkur Electric Power Company"
            case '37':
                return "Hyderabad Electric Supply Company"
            case '48':
                return "Quetta Electric Supply Company"
            case '59':
                return "Tribal Electric Supply Company"

        }
    }

    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = subdivisionName(parseInt(code), subDivisions);
            let dateToPrint = convertDate(new Date());
            let stampData = printStamp(code, offName, name, roleName, dateToPrint);

            const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo) ?
                `Meter Reading Correction Report for ${officeName}` :
                `${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`


            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);
            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Meter Reading Correction Report for ${officeName}`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(title, pageWidth / 2, 25, { align: 'center' });
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text("Name: " + name, pageWidth - 65, 17);
            pdf.text("Designation: " + roleName, pageWidth - 65, 22);


            // Build headers
            const headers = [
                { content: "Tracking Id.", styles: { halign: 'left' } },
                { content: "Reference No.", styles: { halign: 'left' } },
                { content: "Reason", styles: { halign: 'left' } },
                { content: "Approved By", styles: { halign: 'left' } },
                { content: "Registration Date", styles: { halign: 'left' } },
                { content: "Registered By", styles: { halign: 'left' } },

            ];

            const filteredData = tableData.filter(item => {
                const matchProcessedBy = selectedPerson === "" || item.approvedBy === selectedPerson;
                const matchRegisteredBy = selectedPerson1 === "" || item.registeredBy === selectedPerson1;
                return matchProcessedBy && matchRegisteredBy;
            });

            let bodyData = [];

            if (filteredData && filteredData.length > 0) {
                bodyData = filteredData.map((item, id) => [
                    { content: item.trackingId || '-', styles: { halign: 'left' } },
                    { content: item.refNo || '-', styles: { halign: 'left' } },
                    { content: item.reason || '-', styles: { halign: 'left' } },
                    { content: item.approvedBy || '-', styles: { halign: 'left' } },
                    { content: item.registrationDate || '-', styles: { halign: 'left' } },
                    { content: item.registeredBy || '-', styles: { halign: 'left' } }
                ]);
            } else {
                bodyData.push([{
                    content: 'No Data Found',
                    colSpan: headers.length,
                    styles: {
                        halign: 'center',
                        fontSize: 12,
                        fontStyle: 'bold',
                        fillColor: [255, 255, 255],
                        textColor: [255, 0, 0]
                    }
                }]);
            }

            // Generate table
            pdf.autoTable({
                startY: 28,
                head: [headers],
                body: bodyData,
                styles: { cellPadding: 3, fontSize: 8, halign: 'center' },
                theme: 'striped',
                columnStyles: {
                    0: { cellWidth: 38, halign: 'left' }, // Feeder name
                    1: { cellWidth: 30, halign: 'left' }, // Units Received
                    2: { cellWidth: 60, halign: 'left' }, // Units Billed
                    3: { cellWidth: 40, halign: 'left' }, // Units Billed
                    4: { cellWidth: 40, halign: 'left' }, // Units Lost
                    5: { cellWidth: 40, halign: 'left' }, // Units Lost


                },
            });

            // Add page numbers
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            // Save or resolve PDF
            if (print) {
                openJsPdfInNewTab(pdf, `${officeName}- From ${dateFrom} - to ${dateTo} - Meter-Reading-Correction-Report.pdf`);
                resolve(pdf);
            } else {
                resolve(pdf);
            }
        });
    };



    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };



    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };

    const getDateDifference = (startDate, endDate) => {
        // Convert the date strings to Date objects
        const startDates = startDate.split(',')[0]
        const endDates = endDate.split(',')[0]

        const start = new Date(startDates);
        const end = new Date(endDates);

        // Calculate the difference in time (milliseconds)
        const differenceInTime = end - start;

        // Convert time difference from milliseconds to days
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return differenceInDays;
    };

    const handleRemarksClick = (event, remarks) => {
        if (remarks && remarks.trim() !== '') { // Only show popover if remarks have a value
            setAnchorEl(event.currentTarget); // Set the target element for Popover
            setSelectedRemarks(remarks);
        }
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const handleProcessedChange = (e) => {
        const selected = e.target.value;
        setSelectedPerson(selected);
    };
    const handleRegisteredChange = (e) => {
        const selected = e.target.value;
        setSelectedPerson1(selected);
    };

    const currentFilters = {
   officeCode, dateFrom, dateTo
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode, dateFrom, dateTo
  ]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
   getStats(reportOfficeCode, dateFrom, dateTo)

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

    return (
        <>
            {/* Applications Table */}
            <Box className='form-box'>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                    <Box className='application-table' style={{ marginRight: '10px' }}>
                        <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Meter Reading Correction Report</h3>
                        <div className='div-datagrid' >
                            <div className='reports-container' >
                                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>
                                    <div className='field-container'>
                                        <Typography className='field-label'> Date From</Typography>
                                        <input type='date' className='date-field' value={dateFrom} max={getTodayIsoDate()} onChange={(e) => { setDateFrom(clampIsoDateToToday(e.target.value));  }} />
                                    </div>
                                    <div className='field-container'>
                                        <Typography className='field-label'> Date To</Typography>
                                        <input type='date' className='date-field' value={dateTo} max={getTodayIsoDate()} onChange={(e) => { setDateTo(clampIsoDateToToday(e.target.value)); }} />
                                    </div>

                                     {code == 10 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Company</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedCompanyCode}
                                                             onChange={(e) => {
                            handleChangeCompany(e);
                          }}
                                                          >
                                                            <option value="10">Select Company</option>
                                                            {getDiscoCompanyNativeOptions(selectedCompanyCode)}
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 2 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Circle</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={circleCode || ''}
                                                            onChange={(e) => {
                            handleCircleChange(e);
                          }}
                                                          >
                                                            <option value="">All Circle</option>
                                                            {filteredCircles.map((circle) => (
                                                              <option key={circle.circleCode} value={circle.circleCode}>
                                                                {circle.circleName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 3 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Division</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedDivision || ''}
                                                             onChange={(e) => {
                            handleDivisionChange(e);
                          }}
                                                            disabled={!circleCode}
                                                          >
                                                            <option value="">All Division</option>
                                                            {filteredDivisions.map((division) => (
                                                              <option key={division.divisionCode} value={division.divisionCode}>
                                                                {division.divisionName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 4 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Sub-Division</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedSubDivision || ''}
                                                             onChange={(e) => {
                            handleSubDivisionChange(e);
                          }}
                                                            disabled={!selectedDivision}
                                                          >
                                                            <option value="">All Sub-Division</option>
                                                            {filteredSubDivisions.map((subDivision) => (
                                                              <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                                                                {subDivision.subDivisionName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                    <div className="field-container">
                                        <label className="field-label">Registered by:</label>
                                        <select
                                            className="dropdown-field"
                                            style={{ backgroundColor: "white" }}
                                            id="lastModifiedBy"
                                            value={selectedPerson1}
                                            onChange={handleRegisteredChange}
                                        >
                                            <option value="">Select a person</option>
                                            {registeredByOptions.map((person, index) => (
                                                <option key={index} value={person}>
                                                    {person}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    <div className="field-container">
                                        <label className="field-label">Approved by:</label>
                                        <select
                                            className="dropdown-field"
                                            style={{ backgroundColor: "white" }}
                                            id="lastModifiedBy"
                                            value={selectedPerson}
                                            onChange={handleProcessedChange}
                                        >
                                            <option value="">Select a person</option>
                                            {lastModifiedByOptions.map((person, index) => (
                                                <option key={index} value={person}>
                                                    {person}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ marginTop: '10px' }}
                                       onClick={handleGoClick}
        disabled={isGoDisabled || viewBackdrop}
                                    >
                                        Go
                                    </Button>
                                    {/* <div className='field-container'>
                                        <Typography className='field-label'>Category</Typography>
                                        <select value={category} className='dropdown-field' style={{ backgroundColor: 'white' }} onChange={(e) => { setCategory(e.target.value); const selectedOption = e.target.options[e.target.selectedIndex].text; setcategoryName(selectedOption === "All" ? '' : selectedOption); }}>
                                            <option value=''>All</option>
                                            <option value={-1}>Rejected</option>
                                            <option value={0}>Pending</option>
                                            <option value={1}>Approved</option>
                                        </select>
                                    </div> */}
                                    {/* <div className='field-container'>
                                        <button onClick={handleClick} className='primary-button'>
                                            <SearchIcon id="searchBtn" sx={{ color: 'white' }} />
                                        </button>
                                    </div> */}
                                </div>
                                <div className="export-button-container">

                                      <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                                </div>



                            </div>
                            <div className="table-container" style={{ marginBottom: '40px' }}>
                                <div id="pdf-table">
                                    <div style={{ maxHeight: '900px', overflowY: 'auto' }}>
                                        <table className="table" ref={tableRef} style={{ marginBottom: '40px', width: '100%', borderCollapse: 'collapse' }}>
                                            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
                                                <tr style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 3 }}>
                                                    <th colSpan="14" style={{ fontSize: '20px', borderBottom: '2px solid white', textAlign: 'center', backgroundColor: '#d5e5ff', color: 'black', }}>
                                                        {dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo) ?
                                                            `Daily Meter Reading Correction Report for (${officeName})` :
                                                            `Meter Reading Correction Report for (${officeName}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`
                                                        }

                                                    </th>
                                                </tr>
                                                <tr style={{ position: 'sticky', top: '37px', backgroundColor: 'white', zIndex: 1 }}>
                                                    {connectionTypes.map((type, index) => (
                                                        <th
                                                            key={index}
                                                            style={{
                                                                width: `${100 / connectionTypes.length}%`,
                                                                textAlign: 'left',
                                                                border: '5px solid white',
                                                                // backgroundColor: '#d5e5ff',
                                                                // color: 'black',
                                                                backgroundColor: '#eeeff1',
                                                                color: 'black',
                                                                fontSize: '14px',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                            }}
                                                        >
                                                            {type}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tableData.length > 0 ? (
                                                        tableData.map((item, id) => (
                                                            <tr key={id} style={{ backgroundColor: 'white', borderBottom: "1px solid #ccc" }}>
                                                                <td style={{ textAlign: 'left' }}>{item.applicationId || '-'}</td>
                                                                <td style={{ textAlign: 'left' }}>{item.referenceNoToBePostedInIBS || '-'}</td>
                                                                <td style={{
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    maxWidth: '40ch'
                                                                }}>
                                                                    {item.applicationId || '-'}
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>{item.applicationId || '-'}</td>
                                                                <td style={{ textAlign: 'left' }}>{item.applicationId || '-'}</td>
                                                                <td style={{ textAlign: 'left' }}>{item.applicationId || '-'}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="12" style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: 'red' }}>
                                                                No Data Found
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>


                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Box>
            {/* Popover for showing full Remarks */}
            {selectedRemarks && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    disableRestoreFocus
                >
                    <div style={{ padding: '10px' }}>
                        <Typography variant="h6" sx={{ fontSize: '17px' }}>Remarks :</Typography>
                        <Typography sx={{ fontSize: '14px' }}>{selectedRemarks}</Typography>
                    </div>
                </Popover>
            )}
            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}

export default MeterReadingCorrectionReports;